export enum TagTypeEnum {
  NGO = 'NGO',
  CAMPAIGN = 'CAMPAIGN',
}
